const openExternalLink = (url: string): void => {
  if (!url) {
    return;
  }

  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  link.remove();
};

declare global {
  interface Window {
    openExternalLink: (url: string) => void;
  }
}

if (typeof window !== 'undefined') {
  window.openExternalLink = openExternalLink;
}

export { openExternalLink };
